var map = {
	"./arrow-black.svg": "9fb3",
	"./arrow-white.svg": "ef39",
	"./back-black.svg": "76c6",
	"./back-white.svg": "3cc1",
	"./card-bg-grey.svg": "ff8c",
	"./circle--white.svg": "3155",
	"./circle-big.svg": "c0dc",
	"./circle.svg": "869e",
	"./close-black.svg": "443b",
	"./close.svg": "1d1b",
	"./cursor-hand.png": "d838",
	"./enter-black.svg": "cf7c",
	"./gift.png": "4ef4",
	"./gift.svg": "2e5e",
	"./hand-heart.svg": "19fd",
	"./hand-point.svg": "c80d",
	"./hand-rock.svg": "9c0e",
	"./location-black.svg": "6955",
	"./location-white.svg": "b55e",
	"./logo-small.png": "5d57",
	"./logo-small@2x.png": "1a70",
	"./logo-small@3x.png": "4317",
	"./logo-white.png": "39cc",
	"./logo-white@2x.png": "b896",
	"./logo-white@3x.png": "d464",
	"./logo.png": "4ffd",
	"./logo@2x.png": "a5ed",
	"./logo@3x.png": "bfbf",
	"./menu-black.svg": "421b",
	"./menu-white.svg": "91eb",
	"./next-black.png": "8ee6",
	"./play-button.png": "d1ec",
	"./point-right--white.svg": "bef3",
	"./point-right.svg": "66eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";